"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorGenerate = void 0;
const dataRetrive_1 = require("../dataRetrive");
function generateErrorFromResponse(error) {
    var _a;
    if (!error) {
        return {
            code: -1,
            message: "null error",
            data: {},
        };
    }
    // 抛出来是error, error里边有resp. ajax层错误
    const response = error.response;
    if (response && response.data) {
        if (typeof response.data === "string") {
            return {
                code: response.status,
                message: response.data,
                data: {},
            };
        }
        else {
            return response.data;
        }
    }
    // error是resp本身, status 是http code, status有值则判断是resp
    if (error.data && String((_a = error.status) !== null && _a !== void 0 ? _a : "").length > 0) {
        return error.data;
    }
    const code = error.code ? error.code : -1;
    const defaultErrorStr = typeof error === "string" ? error : JSON.stringify(error) || `${error}` || "ajax_unknown_error";
    const message = error.message || error.msg || defaultErrorStr;
    const data = error.data || { isAxiosError: !!error.isAxiosError };
    return {
        code: code,
        message: message,
        data: data,
    };
}
exports.ErrorGenerate = {
    generateError(code, message, data) {
        return {
            code: code === undefined || code === null ? -1 : code,
            message: message === undefined || message === null ? "unknown_error_message" : message,
            data: data === undefined || data === null ? {} : data,
        };
    },
    formatterError(error) {
        const tempError = generateErrorFromResponse(error);
        return (0, dataRetrive_1.getTradeDependencyInstance)().localizeError(tempError);
    },
};
